const ActionType = {
  SET_READ_ONLY_MODE: 'SET_READ_ONLY_MODE',
  SET_EXTERNAL_ACCESS_MODE: 'SET_EXTERNAL_ACCESS_MODE',
  SET_LANGUAGE: 'SET_LANGUAGE',
};

export default ActionType;
